import { render } from "./CookieSettings.vue?vue&type=template&id=00aab055&scoped=true"
import script from "./CookieSettings.vue?vue&type=script&lang=js"
export * from "./CookieSettings.vue?vue&type=script&lang=js"

import "./CookieSettings.vue?vue&type=style&index=0&id=00aab055&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00aab055"]])

export default __exports__